import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/store';
import { updatePolicy } from '../../../../../services/CaseManagementService/policySlice';

const PolicyEffectiveDateEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const policy = useAppSelector((state) => state.policy.currentPolicy);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    // Convert to ISO string for storage, or null if empty
    const isoDate = value ? new Date(value).toISOString() : null;
    dispatch(updatePolicy({ effectiveDate: isoDate }));
  };

  // Convert ISO string back to YYYY-MM-DD format for the date input
  const formatDateForInput = (isoString: string | null | undefined): string => {
    if (!isoString) return '';
    try {
      return new Date(isoString).toISOString().split('T')[0];
    } catch {
      return '';
    }
  };

  return (
    <TextField
      type="date"
      label="Effective Date"
      value={formatDateForInput(policy?.effectiveDate)}
      onChange={handleChange}
      size="small"
      InputLabelProps={{
        shrink: true,
      }}
      sx={{ 
        '& .MuiOutlinedInput-root': {
          backgroundColor: '#ffffff',
        }
      }}
    />
  );
};

export default PolicyEffectiveDateEditor;
